import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default styled(
  withParallax(styled.p`
    color: ${props => props.theme.textSemiDark};
    font-family: 'Galano Classic';
    font-size: 12px;
    font-weight: 400;
    line-height: 23.33px;
    padding: 0;
    max-width: 210px;

    a {
      color: ${props => props.theme.textSemiDark};
    }

    ${media.medium`
      font-size: 1.4vw;
      line-height: 2.8vw;
      max-width: 21vw;
    `}

    ${media.large`
      font-size: 1vw;
      line-height: 2.43vw;
      max-width: 21vw;
    `}
  `),
)`
  margin: 28px 0 0 0;

  ${media.medium`
    margin: 2.8vw 0 0 0;
  `}
`;
